import classNames from "classnames";
import { IconButton } from "@/components/ui/buttons/IconButton";
import { deriveUserNames } from "@/hooks/data/dataQuality";
import { Trash2 } from "lucide-react";
import styles from "./UserListItem.module.css";

export interface UserListItemUser {
  id: number;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  name?: string | null;
}

export interface UserListItemProps<
  TUser extends UserListItemUser = UserListItemUser,
> {
  user: TUser;
  onDelete?: (user: TUser) => void;
  isDeleting?: boolean;
  deleteLabel?: string;
  className?: string;
  "data-testid"?: string;
}

export function UserListItem<TUser extends UserListItemUser>({
  user,
  onDelete,
  isDeleting = false,
  deleteLabel = "Fjern",
  className,
  "data-testid": testId,
}: UserListItemProps<TUser>) {
  const { displayName } = deriveUserNames(user);

  return (
    <div
      className={classNames(styles.container, className)}
      data-testid={testId}
    >
      <div className={styles.userInfo}>
        <span className={styles.userName}>{displayName}</span>
        <span className={styles.userEmail}>{user.email}</span>
      </div>
      {onDelete && (
        <IconButton
          icon={<Trash2 size={16} />}
          aria-label={deleteLabel}
          variant="clear"
          size="sm"
          shape="square"
          disabled={isDeleting}
          onClick={() => onDelete(user)}
          data-testid={testId ? `${testId}-delete` : undefined}
        />
      )}
    </div>
  );
}

UserListItem.displayName = "UserListItem";

export default UserListItem;
